import partMatrix from '@/app/utils/toolkit/business-rules/pension-establishment/partMatrix';

export const pensionSetupMixin = {
  computed: {
    pensions() {
      return this.getItem.pensions;
    },
  },
  methods: {
    async setPartValue(setup) {
      await this.setItem({
        setup: {
          ...setup,
          part: partMatrix(setup, setup.transferBalanceCapKnown),
        },
      });
    },
    async setPensionStatus(status) {
      const updatedPensions = this.pensions.map(pension => ({
        ...pension,
        status: pension.status !== 'STARTED' ? status : pension.status,
      }));
      await this.setItem({ pensions: updatedPensions });
    },
  },
};

export default pensionSetupMixin;
